/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1DeviceResultIDs } from '../models/V1DeviceResultIDs';
import { HttpFile } from '../http/http';

export class V1DeviceSubDetails {
    /**
    * Total number of result objects
    */
    'resultsCount'?: number;
    'ids'?: V1DeviceResultIDs;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "resultsCount",
            "baseName": "results_count",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "ids",
            "baseName": "ids",
            "type": "V1DeviceResultIDs",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1DeviceSubDetails.attributeTypeMap;
    }

    public constructor() {
    }
}

